// GENERATED FILE — do not edit by hand.
// Regenerate with: python3 scripts/build_chrome_strings.py
//
// The ~39 header/footer strings, for every locale. The chrome lives in the root
// layout (outside app/[lang]/, and therefore outside LocaleI18nProvider), so it had
// no way to reach a locale's translations and rendered English on every /{lang} page.
// Importing the full per-locale i18n instances here would ship ~300 KB gzipped of
// translations to every route; this subset costs a few KB. See ./useChromeT.js.
export const CHROME_STRINGS = {
  "de": {
    "accountSettings": "Kontoeinstellungen",
    "affiliate": "Tochtergesellschaft",
    "affiliateGuide": "Affiliate-Leitfaden",
    "aiChat": "KI-Chat",
    "aiGirlfriend": "KI-Freundin",
    "apiDocs": "API-Dokumentation",
    "apiGuide": "API-Leitfaden",
    "businessContact": "Geschäftskontakt",
    "buyGems": "Mit Karte kaufen",
    "chat": "Chat",
    "contact": "Kontakt",
    "contentmoderationpolicy": "Politik der Inhaltsmoderation",
    "contentremoval": "Bericht Inhalt",
    "create": "erstellen.",
    "createAiImages": "KI-Bilder erstellen",
    "dailyReward": "Tägliche Aufgaben",
    "dmcapolicy": "DMCA-Richtlinie",
    "explore": "Erkunden Sie",
    "exploreAiImages": "KI-Bilder entdecken",
    "footerAbout": "Über uns",
    "footerAiTools": "KI-Tools",
    "footerBusinessApi": "Wirtschaft / API",
    "footerServices": "Dienste",
    "footerShop": "Shop",
    "footerSocials": "Soziale Medien",
    "getGems": "Edelsteine erhalten",
    "guide": "Leitfaden",
    "moderationpolicy": "Moderationspolitik",
    "new": "Neu!",
    "privacyPolicy": "Datenschutzbestimmungen",
    "profile": "Profil",
    "refundpolicy": "Erstattungspolitik",
    "search": "Suche",
    "signUp": "Anmeldung",
    "termsOfService": "Bedingungen der Dienstleistung",
    "upgrade": "Upgrade",
    "upgradeToPro": "Auf Pro upgraden"
  },
  "en": {
    "accountSettings": "Account Settings",
    "affiliate": "Affiliate",
    "affiliateGuide": "Affiliate Guide",
    "aiChat": "AI Chat",
    "aiGirlfriend": "AI Girlfriend",
    "apiDocs": "API Docs",
    "apiGuide": "API Guide",
    "businessContact": "Business Contact",
    "buyGems": "Buy with Card",
    "chat": "Chat",
    "contact": "Contact",
    "contentmoderationpolicy": "Content Moderation Policy",
    "contentremoval": "Report Content",
    "create": "Create",
    "createAiImages": "Create AI Images",
    "dailyReward": "Daily Tasks",
    "dmcapolicy": "DMCA Policy",
    "explore": "Explore",
    "exploreAiImages": "Explore AI Images",
    "footerAbout": "About",
    "footerAiTools": "AI Tools",
    "footerBusinessApi": "Business / API",
    "footerServices": "Services",
    "footerShop": "Shop",
    "footerSocials": "Socials",
    "getGems": "Get Gems",
    "guide": "Guide",
    "moderationpolicy": "Moderation Policy",
    "new": "New!",
    "privacyPolicy": "Privacy Policy",
    "profile": "Profile",
    "refundpolicy": "Refund Policy",
    "search": "Search",
    "signUp": "Sign Up",
    "termsOfService": "Terms of Service",
    "upgrade": "Upgrade",
    "upgradeToPro": "Upgrade to Pro"
  },
  "es": {
    "accountSettings": "Configuración de la cuenta",
    "affiliate": "Afiliado",
    "affiliateGuide": "Guía de afiliados",
    "aiChat": "Chat IA",
    "aiGirlfriend": "Novia IA",
    "apiDocs": "Documentación API",
    "apiGuide": "Guía de API",
    "businessContact": "Contacto comercial",
    "buyGems": "Comprar con tarjeta",
    "chat": "Chat",
    "contact": "Póngase en contacto con",
    "contentmoderationpolicy": "Política de moderación de contenidos",
    "contentremoval": "Contenido del informe",
    "create": "Cree",
    "createAiImages": "Crear imágenes IA",
    "dailyReward": "Tareas diarias",
    "dmcapolicy": "Política DMCA",
    "explore": "Explora",
    "exploreAiImages": "Explorar imágenes IA",
    "footerAbout": "Acerca de",
    "footerAiTools": "Herramientas de IA",
    "footerBusinessApi": "Negocios / API",
    "footerServices": "Servicios",
    "footerShop": "Tienda",
    "footerSocials": "Redes sociales",
    "getGems": "Obtener gemas",
    "guide": "Guía",
    "moderationpolicy": "Política de moderación",
    "new": "Novedad",
    "privacyPolicy": "Política de privacidad",
    "profile": "Perfil",
    "refundpolicy": "Política de reembolso",
    "search": "Buscar en",
    "signUp": "Inscribirse",
    "termsOfService": "Condiciones de uso",
    "upgrade": "Actualizar",
    "upgradeToPro": "Mejorar a Pro"
  },
  "fr": {
    "accountSettings": "Paramètres du compte",
    "affiliate": "Affiliation",
    "affiliateGuide": "Guide affilié",
    "aiChat": "Chat IA",
    "aiGirlfriend": "Petite amie IA",
    "apiDocs": "Docs API",
    "apiGuide": "Guide API",
    "businessContact": "Contact commercial",
    "buyGems": "Acheter avec la carte",
    "chat": "Chat",
    "contact": "Contact",
    "contentmoderationpolicy": "Politique de modération du contenu",
    "contentremoval": "Contenu du rapport",
    "create": "Créer",
    "createAiImages": "Créer des images IA",
    "dailyReward": "Tâches quotidiennes",
    "dmcapolicy": "Politique DMCA",
    "explore": "Explorer",
    "exploreAiImages": "Explorer les images IA",
    "footerAbout": "À propos",
    "footerAiTools": "Outils IA",
    "footerBusinessApi": "Entreprise / API",
    "footerServices": "Services",
    "footerShop": "Boutique",
    "footerSocials": "Réseaux sociaux",
    "getGems": "Obtenir des pierres précieuses",
    "guide": "Guide",
    "moderationpolicy": "Politique de modération",
    "new": "Nouveau !",
    "privacyPolicy": "Politique de confidentialité",
    "profile": "Profil",
    "refundpolicy": "Politique de remboursement",
    "search": "Recherche",
    "signUp": "S'inscrire",
    "termsOfService": "Conditions d'utilisation",
    "upgrade": "Mise à niveau",
    "upgradeToPro": "Passer à Pro"
  },
  "hi": {
    "accountSettings": "खाता सेटिंग्स",
    "affiliate": "सहबद्ध",
    "affiliateGuide": "एफिलिएट गाइड",
    "aiChat": "AI चैट",
    "aiGirlfriend": "AI गर्लफ्रेंड",
    "apiDocs": "API डॉक्स",
    "apiGuide": "API गाइड",
    "businessContact": "बिजनेस संपर्क",
    "buyGems": "कार्ड से खरीदें",
    "chat": "चैट",
    "contact": "संपर्क",
    "contentmoderationpolicy": "सामग्री मध्यस्थता नीति",
    "contentremoval": "रिपोर्ट सामग्री",
    "create": "बनाएँ",
    "createAiImages": "AI इमेज बनाएं",
    "dailyReward": "दैनिक कार्य",
    "dmcapolicy": "डीएमसीए नीति",
    "explore": "अन्वेषण करें",
    "exploreAiImages": "AI इमेज एक्सप्लोर करें",
    "footerAbout": "परिचय",
    "footerAiTools": "AI टूल्स",
    "footerBusinessApi": "बिजनेस / API",
    "footerServices": "सेवाएं",
    "footerShop": "शॉप",
    "footerSocials": "सोशल",
    "getGems": "जेम प्राप्त करें",
    "guide": "मार्गदर्शक",
    "moderationpolicy": "मॉडरेशन नीति",
    "new": "नया!",
    "privacyPolicy": "गोपनीयता नीति",
    "profile": "प्रोफ़ाइल",
    "refundpolicy": "रिफंड नीति",
    "search": "खोजें",
    "signUp": "साइन अप करें",
    "termsOfService": "सेवा की शर्तें",
    "upgrade": "अपग्रेड",
    "upgradeToPro": "Pro में अपग्रेड करें"
  },
  "it": {
    "accountSettings": "Impostazioni account",
    "affiliate": "Affiliato",
    "affiliateGuide": "Guida affiliati",
    "aiChat": "Chat IA",
    "aiGirlfriend": "Fidanzata IA",
    "apiDocs": "Documenti API",
    "apiGuide": "Guida API",
    "businessContact": "Contatto business",
    "buyGems": "Acquista con Carta",
    "chat": "Chat",
    "contact": "Contatto",
    "contentmoderationpolicy": "Politica di moderazione dei contenuti",
    "contentremoval": "Contenuto del rapporto",
    "create": "Creare",
    "createAiImages": "Crea immagini IA",
    "dailyReward": "Attività quotidiane",
    "dmcapolicy": "Politica DMCA",
    "explore": "Esplorare",
    "exploreAiImages": "Esplora immagini IA",
    "footerAbout": "Informazioni",
    "footerAiTools": "Strumenti IA",
    "footerBusinessApi": "Affari / API",
    "footerServices": "Servizi",
    "footerShop": "Negozio",
    "footerSocials": "Social",
    "getGems": "Ottenere gemme",
    "guide": "Guida",
    "moderationpolicy": "Politica di moderazione",
    "new": "Nuovo!",
    "privacyPolicy": "Informativa sulla privacy",
    "profile": "Profilo",
    "refundpolicy": "Politica di rimborso",
    "search": "Ricerca",
    "signUp": "Iscriviti",
    "termsOfService": "Termini di servizio",
    "upgrade": "Aggiornamento",
    "upgradeToPro": "Passa a Pro"
  },
  "ja": {
    "accountSettings": "アカウント設定",
    "affiliate": "アフィリエイト",
    "affiliateGuide": "アフィリエイトガイド",
    "aiChat": "AIチャット",
    "aiGirlfriend": "AIガールフレンド",
    "apiDocs": "APIドキュメント",
    "apiGuide": "APIガイド",
    "businessContact": "ビジネス問い合わせ",
    "buyGems": "カードで購入",
    "chat": "チャット",
    "contact": "連絡先",
    "contentmoderationpolicy": "コンテンツ・モデレーション・ポリシー",
    "contentremoval": "コンテンツ削除",
    "create": "作成",
    "createAiImages": "AI画像を作成",
    "dailyReward": "デイリータスク",
    "dmcapolicy": "DMCAポリシー",
    "explore": "エクスペリエンス",
    "exploreAiImages": "AI画像を探索",
    "footerAbout": "概要",
    "footerAiTools": "AIツール",
    "footerBusinessApi": "ビジネス / API",
    "footerServices": "サービス",
    "footerShop": "ショップ",
    "footerSocials": "ソーシャル",
    "getGems": "ジェムを手に入れる",
    "guide": "ガイド",
    "moderationpolicy": "モデレーション・ポリシー",
    "new": "新しい！",
    "privacyPolicy": "プライバシーポリシー",
    "profile": "プロフィール",
    "refundpolicy": "返金ポリシー",
    "search": "検索",
    "signUp": "会員登録",
    "termsOfService": "利用規約",
    "upgrade": "アップグレード",
    "upgradeToPro": "Proにアップグレード"
  },
  "ko": {
    "accountSettings": "계정 설정",
    "affiliate": "제휴",
    "affiliateGuide": "제휴 가이드",
    "aiChat": "AI 채팅",
    "aiGirlfriend": "AI 여자친구",
    "apiDocs": "API 문서",
    "apiGuide": "API 가이드",
    "businessContact": "비즈니스 문의",
    "buyGems": "카드로 구매",
    "chat": "채팅",
    "contact": "연락처",
    "contentmoderationpolicy": "콘텐츠 중재 정책",
    "contentremoval": "콘텐츠 보고",
    "create": "만들기",
    "createAiImages": "AI 이미지 만들기",
    "dailyReward": "일일 작업",
    "dmcapolicy": "DMCA 정책",
    "explore": "탐색",
    "exploreAiImages": "AI 이미지 탐색",
    "footerAbout": "소개",
    "footerAiTools": "AI 도구",
    "footerBusinessApi": "비즈니스 / API",
    "footerServices": "서비스",
    "footerShop": "상점",
    "footerSocials": "소셜",
    "getGems": "보석 얻기",
    "guide": "가이드",
    "moderationpolicy": "중재 정책",
    "new": "신규!",
    "privacyPolicy": "개인정보 보호정책",
    "profile": "프로필",
    "refundpolicy": "환불 정책",
    "search": "검색",
    "signUp": "가입하기",
    "termsOfService": "서비스 약관",
    "upgrade": "업그레이드",
    "upgradeToPro": "Pro로 업그레이드"
  },
  "pt": {
    "accountSettings": "Definições da conta",
    "affiliate": "Filial",
    "affiliateGuide": "Guia de afiliados",
    "aiChat": "Chat IA",
    "aiGirlfriend": "Namorada IA",
    "apiDocs": "Docs da API",
    "apiGuide": "Guia da API",
    "businessContact": "Contato comercial",
    "buyGems": "Comprar com cartão",
    "chat": "Conversa",
    "contact": "Contacto",
    "contentmoderationpolicy": "Política de moderação de conteúdos",
    "contentremoval": "Conteúdo do relatório",
    "create": "Criar",
    "createAiImages": "Criar imagens IA",
    "dailyReward": "Tarefas diárias",
    "dmcapolicy": "Política DMCA",
    "explore": "Explorar",
    "exploreAiImages": "Explorar imagens IA",
    "footerAbout": "Sobre",
    "footerAiTools": "Ferramentas de IA",
    "footerBusinessApi": "Negócios / API",
    "footerServices": "Serviços",
    "footerShop": "Loja",
    "footerSocials": "Redes sociais",
    "getGems": "Obter gemas",
    "guide": "Guia",
    "moderationpolicy": "Política de moderação",
    "new": "Novo!",
    "privacyPolicy": "Política de privacidade",
    "profile": "Perfil",
    "refundpolicy": "Política de reembolso",
    "search": "Pesquisar",
    "signUp": "Inscrever-se",
    "termsOfService": "Termos do serviço",
    "upgrade": "Atualização",
    "upgradeToPro": "Atualizar para Pro"
  },
  "zh-CN": {
    "accountSettings": "账户设置",
    "affiliate": "附属机构",
    "affiliateGuide": "联盟指南",
    "aiChat": "AI 聊天",
    "aiGirlfriend": "AI 女友",
    "apiDocs": "API 文档",
    "apiGuide": "API 指南",
    "businessContact": "商务联系",
    "buyGems": "持卡购买",
    "chat": "聊天",
    "contact": "联系方式",
    "contentmoderationpolicy": "内容审核政策",
    "contentremoval": "报告内容",
    "create": "创建",
    "createAiImages": "创建 AI 图片",
    "dailyReward": "日常任务",
    "dmcapolicy": "DMCA 政策",
    "explore": "探索",
    "exploreAiImages": "探索 AI 图片",
    "footerAbout": "关于",
    "footerAiTools": "AI 工具",
    "footerBusinessApi": "商务 / API",
    "footerServices": "服务",
    "footerShop": "商店",
    "footerSocials": "社交",
    "getGems": "获取宝石",
    "guide": "指南",
    "moderationpolicy": "修改政策",
    "new": "新！",
    "privacyPolicy": "隐私政策",
    "profile": "简介",
    "refundpolicy": "退款政策",
    "search": "搜索",
    "signUp": "注册",
    "termsOfService": "服务条款",
    "upgrade": "升级",
    "upgradeToPro": "升级到 Pro"
  }
}
